import { IAllocationDimension } from "helpers/allocation-dimension";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { ITargetsData, ITargetsDataError, RuleType } from "components/product-collection/footer/types";
import { isValidDoor } from "components/product-collection/footer/components/left-side/add-target-values/paste-container/target-values-grid";
import { parseDoorIdToMap } from "components/product-collection/footer/components/left-side/add-target-values/paste-container/paste-container";

export class OnlyExistingDoorsRule extends Validator<ITargetsData[], ITargetsDataError> {
    allocationDimension: IAllocationDimension;
    keyField: string;

    constructor(keyField: string, allocationDimension: IAllocationDimension) {
        super();
        this.allocationDimension = allocationDimension;
        this.keyField = keyField;
    }

    validate(model: ITargetsData[], errors: ITargetsDataError): ITargetsDataError {
        const doors = parseDoorIdToMap([this.allocationDimension]);
        let unknownIds = [];
        if (!errors[RuleType.OnlyExistingDoorsRule] && this.allocationDimension) {
            unknownIds = [
                ...model.reduce((acc, item) => {
                    const rowId = `${item[this.keyField]}`;

                    !isValidDoor(rowId, doors, [], "") && acc.add(rowId);
                    return acc;
                }, new Set()),
            ];
        }

        const validationErrors = unknownIds.length
            ? {
                  ...errors,
                  [RuleType.OnlyExistingDoorsRule]: formatMessage(
                      "Your file contains unrecognized door ID(s): |ids|. Please remove these rows from your file.",
                      {
                          ids: unknownIds.join(", "),
                      }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
